module.exports = __webpack_public_path__ + "1d1262d995727ec8063e37ae2a96e792.ttf";